/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BfeResponse } from '../model/bfeResponse';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BfeViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param tid 
     * @param year 
     * @param vin 
     * @param tgnr 
     * @param regNo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBfeApiData(tid?: string, year?: string, vin?: string, tgnr?: string, regNo?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BfeResponse>>;
    public getBfeApiData(tid?: string, year?: string, vin?: string, tgnr?: string, regNo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BfeResponse>>>;
    public getBfeApiData(tid?: string, year?: string, vin?: string, tgnr?: string, regNo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BfeResponse>>>;
    public getBfeApiData(tid?: string, year?: string, vin?: string, tgnr?: string, regNo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tid !== undefined && tid !== null) {
          queryParameters = queryParameters.set('tid', <any>tid);
        }
        if (year !== undefined && year !== null) {
          queryParameters = queryParameters.set('year', <any>year);
        }
        if (vin !== undefined && vin !== null) {
          queryParameters = queryParameters.set('vin', <any>vin);
        }
        if (tgnr !== undefined && tgnr !== null) {
          queryParameters = queryParameters.set('tgnr', <any>tgnr);
        }
        if (regNo !== undefined && regNo !== null) {
          queryParameters = queryParameters.set('regNo', <any>regNo);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BfeResponse>>(`${this.basePath}/api/BfeView`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
